// Zentrale Projektionskonfiguration für die 2D-Mehrtafelprojektion im
// Drucken-Modal (print_plan_2d_views.js) — ISO 5456-2, Winkelprojektion.
//
// Unterscheidet bewusst zwei getrennte Konzepte, die vorher an mehreren
// Stellen im Code vermischt waren:
//   - "Blickrichtung"/view direction: welche Fassade eine Ansicht zeigt
//     (bestimmt NUR die Kamera in directionCameraSetup(), print_plan_2d_views.js
//     — bleibt bei jeder Projektionsmethode unverändert, wird hier NICHT
//     berührt).
//   - "Platzierung"/placement direction: an welcher Seitenkante des
//     Zeichnungsblatts/des Referenzfensters die Ansicht abgelegt wird.
//
// Europäische Erstwinkelprojektion (First-Angle, ISO 5456-2 — die in der
// Schweiz/EU übliche Norm): das Objekt liegt gedanklich ZWISCHEN Betrachter
// und Projektionsebene, die Ansicht "fällt" also auf die dem Betrachter
// GEGENÜBERLIEGENDE Seite. Eine Ansicht "von Norden" (Betrachter steht im
// Norden, blickt nach Süden) wird deshalb auf der SÜD-Seite des Blattes
// platziert, nicht auf der Nord-Seite. Amerikanische Drittwinkelprojektion
// (Third-Angle) platziert stattdessen auf derselben Seite wie die
// Blickrichtung — das war der Bug: der Code hat bislang implizit
// Third-Angle-Platzierung verwendet (Button "Nord" -> Fenster oben), obwohl
// die Beschriftungen/Kamera bereits First-Angle-Blickrichtungen zeigten.
//
// "top" (Draufsicht) hat keine Gegenseite in diesem Schema (nur 5 Ansichten
// statt der klassischen 6, keine separate Unter-/Rückansicht) und bleibt bei
// beiden Methoden an ihrer eigenen Position (Kreuzmitte).
export const PROJECTION_METHOD = 'first-angle';

// Diagonalansichten (ISO-Ecken): dieselbe Gegenseiten-Logik wie bei den 4
// Haupt-Himmelsrichtungen, nur auf die 4 Diagonalen erweitert — eine Ansicht
// "von Nordosten" wird First-Angle-konform auf der Südwest-Seite platziert.
const FIRST_ANGLE_PLACEMENT = {
  north: 'south', south: 'north', east: 'west', west: 'east', top: 'top',
  northeast: 'southwest', southwest: 'northeast', northwest: 'southeast', southeast: 'northwest'
};
const THIRD_ANGLE_PLACEMENT = {
  north: 'north', south: 'south', east: 'east', west: 'west', top: 'top',
  northeast: 'northeast', southwest: 'southwest', northwest: 'northwest', southeast: 'southeast'
};

function placementTable() {
  return PROJECTION_METHOD === 'first-angle' ? FIRST_ANGLE_PLACEMENT : THIRD_ANGLE_PLACEMENT;
}

// Blickrichtung -> Seite, an der die Ansicht abgelegt wird (Kreuz-Layout im
// Editor UND identisch beim Druck-/PDF-/SVG-Export, da beide Pfade dieselbe
// gespeicherte win.xMm/zMm-Position lesen, siehe viewWindowsPrintHtml2D()).
export function placementDirectionFor(viewDirection) {
  return placementTable()[viewDirection] || viewDirection;
}

// Umkehrung: Seite, an der eine Ansicht liegt (z.B. weil ein Fenster dorthin
// gezogen/angedockt wurde) -> welche Blickrichtung/Kamera dort gezeigt werden
// muss. Für beide Methoden ist die Tabelle selbstinvers (Nord<->Süd,
// Ost<->West bei First-Angle; Identität bei Third-Angle), daher genügt
// dieselbe Lookup-Funktion in beide Richtungen.
export function viewDirectionForPlacement(placementDirection) {
  return placementTable()[placementDirection] || placementDirection;
}
